import React, { ReactNode, useEffect } from 'react';
import { ModalsKeys } from 'global';
import { useDispatch } from 'react-redux';
import { CreateEquipmentModalOld, ModalsContainer } from 'components/shared/Modals';
import { deskingActions } from '../../model';
import { SaleModeProvider } from '../../context';
import { PanelFormContainerProps } from '../../types';
import { PanelFormContainer } from './panelForm/PanelFormContainer';
import {
  ProductCatalogDialog,
  ProposalProductsDialog,
  ConfirmSaveDraftDialog,
  NotifyAboutRemovedProductsDialog,
} from '../dialogs';

export const DeskingPanel = (props: PanelFormContainerProps) => {
  const dispatch = useDispatch();

  const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
    [ModalsKeys.ProductCatalogDialog]: <ProductCatalogDialog />,
    [ModalsKeys.ProposalProductsDialog]: <ProposalProductsDialog />,
    [ModalsKeys.DeskingConfirmSaveDraftDialog]: <ConfirmSaveDraftDialog />,
    [ModalsKeys.DeskingNotifyAboutRemovedProductsDialog]: <NotifyAboutRemovedProductsDialog />,
    [ModalsKeys.CreateEquipment]: <CreateEquipmentModalOld inventoryActions={props.inventoryActions} />,
  };

  useEffect(() => {
    if (props?.configurationByAccount?.state) {
      dispatch(
        deskingActions.updateMenuBuilderViewType({
          type: props.configurationByAccount.state.menuBuilderViewType,
        })
      );
    }
  });

  useEffect(
    () => () => {
      dispatch(deskingActions.clearState());
    },
    [dispatch]
  );

  return (
    <>
      <SaleModeProvider initialValues={props?.configurationByAccount?.saleMode}>
        <PanelFormContainer {...props} />
      </SaleModeProvider>

      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </>
  );
};
